// Application state using Observable pattern
import { Observable } from './state';
import type { ActiveSegment } from '../types/segment';
import type { SupportedLocale } from '../types/locale';
import { DEFAULT_LOCALE } from '../content/config';

// Application state
export const appState = {
  activeSegment: new Observable<ActiveSegment | null>(null),
  locale: new Observable<SupportedLocale>(DEFAULT_LOCALE),
  isPanelOpen: new Observable<boolean>(false),
  openedViaKeyboard: new Observable<boolean>(false),
};
